import ShButton from "@/components/Helpers/ShButton";
import RecordsShoppingCart from "../../Connections/RecordsShoppingCart";
import AgentActions from "@/components/AgentActions";
import dropdownElements from './dropdownElements';
// @vue/component
export default {
  name: "TheMainMenu",

  components: {
    RecordsShoppingCart,
    ShButton,
    AgentActions
  },

  props: {
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      dropdownItems: dropdownElements.menuItems,
      areTabsInFirstCategory:
        this.$store.getters["authorization/acl"].hasPermission("projects_access") ||
        this.$store.getters["authorization/acl"].hasPermission("campaigns_access") ||
        this.$store.getters["authorization/acl"].hasPermission("surveys_access"),
      areTabsInSecondCategory:
        this.$store.getters["authorization/acl"].hasPermission("blacklist_access") ||
        this.$store.getters["authorization/acl"].hasPermission("address_book_access") ||
        this.$store.getters["authorization/acl"].hasPermission("callplanner_menu_access"),
      areTabsInThirdCategory: this.$store.getters["authorization/acl"].hasPermission(
        "reports_access"
      )
    };
  },
  computed: {
    shoppingCart() {
      return this.$store.getters["record/recordsCart"];
    },
    getStateOfSocketServer() {
      return this.$store.getters["global/stateSocketServer"];
    },
    dropdownItemCounter() { 
      return this.dropdownItems.filter(item => this.user.permissions.includes(item.permission)) || [];
    }
  }
};
